var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"home","d":"M8.328,2.343a.461.461,0,0,0-.572,0L1.125,7.516l.572.729.812-.637v5.713a.923.923,0,0,0,.923.923h9.229a.923.923,0,0,0,.923-.923V7.613l.812.632.572-.724Zm.642,10.978H7.124V9.629H8.969Zm.923,0V9.629a.923.923,0,0,0-.923-.923H7.124a.923.923,0,0,0-.923.923v3.692H3.432V6.889L8.047,3.294l4.614,3.6v6.428Z","transform":"translate(-1.125 -2.244)","fill":"#aaa"}));
}

Home.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 13.843 12","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Home;

Home.default = Home;
